module.exports = __webpack_public_path__ + "static/media/sagar-bg.15d68b5b.mp4";